import { render, staticRenderFns } from "./ChangePassComplete.vue?vue&type=template&id=287a561c&"
import script from "./ChangePassComplete.vue?vue&type=script&lang=js&"
export * from "./ChangePassComplete.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/content.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports